import { render } from "./Hero.vue?vue&type=template&id=3c28f74c&scoped=true&ts=true"
import script from "./Hero.ts?vue&type=script&lang=ts&external"
export * from "./Hero.ts?vue&type=script&lang=ts&external"

import "./Hero.vue?vue&type=style&index=0&id=3c28f74c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c28f74c"]])

export default __exports__